import React, { useState, useEffect } from "react";
import "./TankLevel.css";

export default function TankLevel(props) {
  const {
    isSmall = false,
    progressValue = 8000,
    recenter = false,
    className = "",
    maxTankLevel = 9000,
    displayUnavailable = false,
  } = props;
  const [selectedLine, setSelectedLine] = useState(1);
  const [pointerPosition, setPointerPosition] = useState(0);
  const selectLine = (index) => {
    setSelectedLine(index);
  };
  const safeProgressValue = Number(progressValue);
  const safeMaxTankLevel =
    Number(maxTankLevel) > 0 ? Number(maxTankLevel) : 100;
  const calculatedPositionRaw = (safeProgressValue / safeMaxTankLevel) * 100;
  const calculatedPosition = Number.isFinite(calculatedPositionRaw)
    ? Math.max(0, Math.min(100, calculatedPositionRaw))
    : 0;

  useEffect(() => {
    setPointerPosition(100 - calculatedPosition); // Invert to move the pointer upwards
  }, [calculatedPosition]);

  const colors = isSmall
    ? [
        "#23CBD8",
        "#3BE0E0",
        "#3BE0E0",
        "#3BE0E0",
        "#3BE0E0",
        "#8EF9FA",
        "#8EF9FA",
        "#8EF9FA",
        "#8EF9FA",
        "#8EF9FA",
        "#CEED4F",
        "#DAF17B",
        "#FEA9C1",
        "#FD5484",
        "#FC2965",
      ]
    : [
        "#23CBD8",
        "#23CBD8",
        "#23CBD8",
        "#23CBD8",
        "#3BE0E0",
        "#3BE0E0",
        "#3BE0E0",
        "#3BE0E0",
        "#69F0F3",
        "#69F0F3",
        "#8EF9FA",
        "#8EF9FA",
        "#8EF9FA",
        "#8EF9FA",
        "#8EF9FA",
        "#8EF9FA",
        "#C2E823",
        "#DAF17B",
        "#E7F6A7",
        "#FEA9C1",
        "#FD7FA3",
        "#FD5484",
        "#FC2965",
        "#FC2965",
      ];

  const numLines = isSmall ? 15 : 24;
  const fillLineIndex = Math.round(numLines * (1 - calculatedPosition / 100));
  const emptyBarColor = "#1a2740";
  const center = recenter ? "recenter" : "";
  const small = isSmall ? "small" : "";
  const pointerTop = displayUnavailable ? "50%" : `${pointerPosition + 5}%`;
  const displayProgressValue = displayUnavailable
    ? "--"
    : `${Number(safeProgressValue).toFixed()} L`;
  const displayPercentageValue = displayUnavailable
    ? "--"
    : calculatedPosition.toFixed(2);
  return (
    <div className={`lines-main-container ${className} ${center} ${small}`}>
      <div className="lines-container-heading">Tank level</div>
      <div className="group-container">
        <div className="pointer-container" style={{ top: pointerTop }}>
          {!isSmall ? (
            <span
              style={{
                fontSize: "12px",
                marginTop: "1.4px",
                color: "white",
              }}
            >
              {displayProgressValue}{" "}
            </span>
          ) : null}
          {!displayUnavailable && <div className="lines-container-pointer" />}
        </div>
        <div className="lines-container">
          {Array.from({ length: numLines }, (_, index) => (
            <div
              key={index}
              className={`lines-container-single ${
                selectedLine === index ? "selected" : ""
              }`}
              style={{
                background:
                  index >= fillLineIndex
                    ? colors[index % colors.length]
                    : emptyBarColor,
              }}
              onClick={() => selectLine(index)}
            ></div>
          ))}
        </div>
      </div>
      <div className="percentage-value">
        {displayPercentageValue}
        %
      </div>
    </div>
  );
}
